import React, { useState } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {dt, t} from 'l10n';
import {formatCount} from "../../utils/media";

import {likeAmateurFilm} from 'reducers/amateurFilm';
import {likeWallMaterial, denounceWallMaterial} from 'reducers/wallMaterial';

import {getLoginPath} from "../../utils/url";
import ModalBecomeXXL from "../modals/ModalBecomeXXL";

const MaterialStats = ({ material, currentUser, likeWallMaterial, likeAmateurFilm, denounceWallMaterial, history }) => {
    const [showModal, setShowModal] = useState(false);
    const wallMaterial = !!material.type;

    const onLikeMaterial = () => {
        if (currentUser.isLoggedIn()) {
            if (currentUser.isXXL()) {
                if (wallMaterial) {
                    likeWallMaterial({ id: material.id });
                } else {
                    likeAmateurFilm({ id: material.id });
                }
            } else {
                setShowModal(true)
            }
        } else {
            history.push(getLoginPath(location.pathname + location.search) );
        }
    };

    const onDenounceMaterial = () => {
        if (currentUser.isLoggedIn()) {
            if (currentUser.isXXL()) {
                denounceWallMaterial({ id: material.id })
            } else {
                setShowModal(true)
            }
        } else {
            history.push(getLoginPath(location.pathname + location.search) );
        }
    };

    return (
        <div className="stats">
            {showModal && <ModalBecomeXXL show={true} closeFn={() => setShowModal(false)} />}
            <div className="buttons">
                {!material.is_denounced &&
                    <button className={`like ${material.is_liked ? 'liked' : ''}`} onClick={onLikeMaterial}>
                        {dt('wall_material', material.is_liked ? 'Liked' : 'Like')}
                        {material.like_count ? ('(' + formatCount(material.like_count) + ')') : null}
                    </button>
                }
                {!material.is_liked && wallMaterial &&
                    <button className={`denounce ${material.is_denounced ? 'denounced' : ''}`} onClick={onDenounceMaterial}>
                        {dt('wall_material', material.is_denounced ? 'Denounced' : 'Denounce')}
                        {material.denounce_count ? ('(' + formatCount(material.denounce_count) + ')') : null}
                    </button>
                }
            </div>
            {!material.is_denounced && !material.is_liked && wallMaterial &&
                <p className="ui-mini denounce-text">{dt('wall_material', 'Denounce this post if it is offensive or contrary to the Terms of BobTV.')}</p>
            }
            {((!wallMaterial || material.type === "video") && material.views) &&
                <p className="counter">{dt('amateur_film', '%1 views', formatCount(material.views))}</p>
            }
        </div>
    )
};

MaterialStats.propTypes = {
    history: PropTypes.object.isRequired,
    material: PropTypes.object.isRequired,
    currentUser: PropTypes.object.isRequired,
    likeAmateurFilm: PropTypes.func.isRequired,
    likeWallMaterial: PropTypes.func.isRequired,
    denounceWallMaterial: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    currentUser: state.currentUser
});

const mapDispatchToProps = ({
    likeAmateurFilm,
    likeWallMaterial,
    denounceWallMaterial,
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MaterialStats));



// WEBPACK FOOTER //
// ./src/components/materialPage/stats.js